import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {dateFormat} from '../../../tools/formatters';
import _ from 'lodash'
import StarIcon from '../../Icons/Star';

import './style.scss';
import './mobile.scss';
import Paginator from '../../Paginator';
import {textKeysReplacement} from '../../../tools/helpers';

const ReviewsList = ({reviews, applicationState, className = '', ...props}) => {
  const rev = props.limit ? reviews.slice(0, props.limit) : reviews;
  return (
    <>
      <div className={`reviews-list ${className}`}>
        {
          rev.map((review) => {
            return props.full ? (
              <div key={review.id} className='reviews-list__item'>
                <div className='reviews-list__item-top'>
                  <div className='reviews-list__item-top-left'>
                    <div className='reviews-list__item-author'>{review.anonymous ? 'Аноним' : review.author}</div>
                    <div className='reviews-list__item-date'>{dateFormat(review.created_at)}</div>
                  </div>
                  <div className='reviews-list__item-stars'>
                    {_.times(review.stars, (i) => <StarIcon key={i} />)}
                  </div>
                </div>
                <div className='reviews-list__item-content'>
                  {
                    review.merits ?
                      <div className='reviews-list__item-content-part'>
                        <b>Достоинства: </b>
                        <span
                          dangerouslySetInnerHTML={{__html: review.merits}}
                        />
                      </div>
                      : null
                  }
                  {
                    review.limitations ?
                      <div className='reviews-list__item-content-part'>
                        <b>Недостатки: </b>
                        <span
                          dangerouslySetInnerHTML={{__html: review.limitations}}
                        />
                      </div>
                      : null
                  }
                  {
                    review.comment ?
                      <div className='reviews-list__item-content-part'>
                        <b>Комментарии: </b>
                        <span
                          dangerouslySetInnerHTML={{__html: review.comment}}
                        />
                      </div>
                      : null
                  }
                  {
                    review.answer ?
                      <div className='reviews-list__item-content-part reviews-list__item-content-part_answer'>
                        <b>Ответ магазина: </b>
                        <span
                          dangerouslySetInnerHTML={{__html: review.answer}}
                        />
                      </div>
                      : null
                  }
                </div>
              </div>
            ) : (
              <div key={review.id} className='reviews-list__item'>
                <div className='reviews-list__item-top'>
                  <div className='reviews-list__item-top-left'>
                    <div className='reviews-list__item-author'>{review.author}</div>
                    <div className='reviews-list__item-date'>{dateFormat(review.created_at)}</div>
                  </div>
                  <div className='reviews-list__item-stars'>
                    {_.times(review.stars, (i) => <StarIcon key={i} />)}
                  </div>
                </div>
                <div className='reviews-list__item-content'>
                  {review.comment}
                </div>
              </div>
            );
          })
        }
      </div>
      {
        props.paginator ?
          <Paginator
            per_page={props.paginator.per_page}
            total={props.paginator.total}
            pages={props.paginator.pages}
            page={props.paginator.page}
            onChange={props.paginator.onChange}
          />
          : null
      }
    </>
  );
};

const mapStateToProps = ({applicationState}) => {
    return {
      applicationState
    };
  },

  withConnect = connect(
    mapStateToProps
  );

export default compose(withConnect)(ReviewsList);

